// import React , {useState , useEffect} from 'react';
// import { Link  ,useHistory } from 'react-router-dom';
// import swal from 'sweetalert';


// import logo1 from '../assets/images/logo-kar.jpeg';

// import { useSelector, useDispatch } from 'react-redux';

// import Loader from "react-loader-spinner";



// const Header =(props)=> {

//   const [total1 , settotal1] = useState(0)
//     const [search , setSearch] = useState("")
//     const [DataPart2 , setDataPart2] = useState([])
//     const [UserDatat , setUserDatat] = useState({})
//     const [userHeader , setuserHeader] = useState(false)
//     const [menu1 , setmenu1] = useState(false)
//     const [adminHeader , setadminHeader] = useState(false)
//     const [displayMenu , setdisplayMenu] = useState(false)
//     const [MainLine , setMainLine] = useState("")
//     const [MainForum , setMainForum] = useState(false)
//     const [MainCatogories , setMainCategories] = useState([])
//     const [SubCategories , setSubCategories] = useState([])
//     const [SubClassCategories , setSubClassCategories] = useState([])
//     const [fvalue , setfvalue] = useState([])
//     const [fvalue1 , setfvalue1] = useState([])
//     const [fg , setfg] = useState(true)
//     const [abc , setabc] = useState(false)
//     const [DisplaySearch , setDisplaySearch] = useState(false)
//     const [DisplayMenu , setDisplayMenu] = useState(false)
//     const [bht , setbht] = useState("")
//     const [mainUser , setmainUser] = useState({})
//     const [couponShow1 , setcouponShow1] = useState(false)
//     const [name, setname] = useState("") 
//     const [email, setemail] = useState("") 
//     const [message, setmessage] = useState("") 
//     const [photo, setphoto] = useState("") 
//     const [allmessage , setallmessage] = useState([])
//     const [cart1 , setcart1] = useState([])
//     const [fav1 , setfav1] = useState([])
//     // const [photo, setphoto] = useState("") 

//     let history = useHistory();


//     useEffect(() =>{
//       document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
//       document.getElementById("menu-mobile-1").style.visibility = "hidden"
//       document.getElementById("menu-mobile-2").style.visibility = "hidden"
//       var data1 =  JSON.parse(localStorage.getItem("Cart")) ?  JSON.parse(localStorage.getItem("Cart"))  : []
//       var data2 =  JSON.parse(localStorage.getItem("Fav")) ?  JSON.parse(localStorage.getItem("Fav")) : []
//       setcart1(data1)
//       setfav1(data2)
//       // let data5 =  JSON.parse(localStorage.getItem("CartPrice")) 
//       // settotal1(data5)
//       let j = 0 
//       data1.map((item,i)=>{
//         j = item.Total_Product_Price + j
//      })
//      settotal1(j)
//         if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
        
//         // fetch("https://garden-oasis-landscapping-main-back.vercel.app/Forum",{
//         //     method: "GET",
//         //      headers :  {
//         //      "Content-Type" : "application/json" , 
//         //  } ,
//         // })
//         // .then(res=>res.json())
//         // .then(res1=>{
//         //     console.log(res1[0]);
//         //     setMainForum(res1[0].student)
        
//         // })
//         fetch("https://garden-oasis-landscapping-main-back.vercel.app/CourseAllSubCategories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res2=>res2.json())
//         .then(res3=>{
//             let data = res3.sort((a, b) => {
//                 return a.sort - b.sort;
//             });
//             console.log(data);
//             setSubClassCategories(data)
//         })
//         fetch("https://garden-oasis-landscapping-main-back.vercel.app/AllCategories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res2=>res2.json())
//         .then(res3=>{
//             // let dat1 = []
//             // res3.map((res55,c)=>{
//             //     dat1.push(0)
//             // })
//             // setfvalue1(dat1)
//             // let data = res3.sort((a, b) => {
//             //     return a.sort - b.sort;
//             // });
//             let unique_values = res3
//         .map((item) => item.CategoriesName)
//         .filter(
//             (value, index, current_value) => current_value.indexOf(value) === index
//         );
//             setSubCategories(unique_values)        
//         }) 

//         fetch("https://garden-oasis-landscapping-main-back.vercel.app/MainCatogories",{
//             method: "GET",
//              headers :  {
//              "Content-Type" : "application/json" , 
//          } ,
//         })
//         .then(res3=>res3.json())
//         .then(res4=>{
//             let dat = []
//             let dat1 = []
//             res4.map((res55,c)=>{
//                 dat.push(res55)
//                 dat1.push(0)
//             })
//                         console.log(dat)
//             let data = dat.sort((a, b) => {
//                 return a.sort - b.sort;
//             });
//             setMainCategories(data)
//             console.log(data)
//             setfvalue(dat1)
//         })
//       //   fetch("https://garden-oasis-landscapping-main-back.vercel.app/AllUserShowMessage",{
//       //     method: "GET",
//       //      headers :  {
//       //      "Content-Type" : "application/json" , 
//       //  }
//       // })
//       // .then(res=>res.json())
//       // .then(res1=>{
//       //     setallmessage(res1)
//       //     console.log(res1)
//       //  const Chat1 = res1.filter((user,j)=>{
//       //      if(JSON.parse( localStorage.getItem("Chat User Data"))){
//       //          if(user.user_id === JSON.parse( localStorage.getItem("Chat User Data")).email ){
//       //             return user
//       //          }
//       //          }
//       //         })
//       //         console.log(Chat1)
//       //     setallmessage(Chat1)
//       // })
//         // if ( JSON.parse(localStorage.getItem("Admin")) ){
//         //     setadminHeader(true)
//         //     setuserHeader(false)
//         //     setUserDatat([])
//         // }
//         // else if ( JSON.parse(localStorage.getItem("User"))  ){
//         //     setuserHeader(true)
//         //     setadminHeader(false)
//         //     setUserDatat(JSON.parse(localStorage.getItem("User")))
//         // }
//         // else{
//         //     setadminHeader(false)
//         //     setUserDatat([])
//         //     setuserHeader(false)

//         // }
//         const inter = setInterval(()=>{
//         //     if ( JSON.parse(localStorage.getItem("Admin")) ){
//         //     setadminHeader(true)
//         //     setuserHeader(false)
//         //     setUserDatat([])
//         // }
//         // else if ( JSON.parse(localStorage.getItem("User"))  ){
//         //     setuserHeader(true)
//         //     setadminHeader(false)
//         //     setUserDatat(JSON.parse(localStorage.getItem("User")))
//         // }
//         // else{
//         //     setadminHeader(false)
//         //     setUserDatat([])
//         //     setuserHeader(false)

//         // }
//       //   fetch("https://garden-oasis-landscapping-main-back.vercel.app/AllUserShowMessage",{
//       //     method: "GET",
//       //      headers :  {
//       //      "Content-Type" : "application/json" , 
//       //  }
//       // })
//       // .then(res=>res.json())
//       // .then(res1=>{
//       //     setallmessage(res1)
//       //     console.log(res1)
//       //  const Chat1 = res1.filter((user,j)=>{
//       //      if(JSON.parse( localStorage.getItem("Chat User Data"))){
//       //          if(user.user_id === JSON.parse( localStorage.getItem("Chat User Data")).email ){
//       //             return user
//       //          }
//       //          }
//       //         })
//       //         console.log(Chat1)
//       //     setallmessage(Chat1)
//       // })
//             var data1 =  JSON.parse(localStorage.getItem("Cart")) 
//          if (data1) {
//              setDataPart2(data1)
//              setcart1(data1)
//             //  const data = DataPart2.length  
//             //  setDataPart2(data)
//             }
//          else setDataPart2(0)
//             var data6 =  JSON.parse(localStorage.getItem("Fav")) 
//          if (data6) {
//              setfav1(data6)
//             //  const data = DataPart2.length  
//             //  setfav1(data)
//             }
//          else setfav1(0)

//          if( JSON.parse(localStorage.getItem("user main")) ) setmainUser(JSON.parse(localStorage.getItem("user main")))
        
       

//         },3000)
        
//         return () => clearInterval(inter);
//     },[])
  

//     const changeFruit = (goto1) => {
//       // setCurrentFruit(newFruit)
//       // history.push(goto);
//       window.location = goto1;
//     }
    
    
    
//     // function redirect(goto){
//     //   if (goto != '') {
//     //       props.history.push(goto)
//     //       window.location = goto;
//     //   }
//     // }
//     // document.getElementById('cat1').onchange = function(){
//     //   var goto = this.value;
//     //   redirect(goto);
      
//     // };

//     const SubmitData4534 = (e) =>{
      
//       e.preventDefault()
//       setDisplaySearch(true)
//       console.log("df")
//       setDisplayMenu3()
//       localStorage.removeItem("SearchData")

//           fetch("https://garden-oasis-landscapping-main-back.vercel.app/SearchProduct",{
//                                   method: "POST",
//                                   headers :  {
//                                       "Content-Type" : "application/json" , 
//                                   } ,
//                                   body : JSON.stringify({
//                                       search : search.toLowerCase() ,
      
//                                   })
//                               })
//                               .then(res=>res.json())
//                               .then((res1)=>{ 
//                                 setDisplaySearch(false)

//                                   console.log(res1) 
//                                   const SearchProductItem = []
                                  
//                                   let search1 = search.split(" ")
//                                 res1.map((res2,i)=>{
//                                     // console.log(res2)
//                                     var Name = res2.Product_Name.toLowerCase().split(" ")
//                                      var Title = res2.Product_Title.toLowerCase().split(" ")
//                                     // console.log(Name , Title)
//                                     for (let j = 0; j < search1.length; j++) {
                                      
//                                       Name.map((res3,i)=>{
  
//                                           if (res3 === search1[j].toLowerCase().trim()){
//                                               SearchProductItem.unshift(res2)
//                                           }
//                                       })
//                                       Title.map((res4,i)=>{
//                                         if (res4 === search1[j].toLowerCase().trim()){
//                                           SearchProductItem.unshift(res2)
//                                         }
//                                       })
//                                     }
//                                 })
//                                   console.log(SearchProductItem)    

//                                   console.log(SearchProductItem,props)
//                                   let uniq = [...new Set(SearchProductItem)];
      
//                                   localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                  
//                                   setTimeout(()=>{
//                                       history.push("/search/product-item");
      
//                                       // return <Redirect push to="/shop/search/product-item" /> 
//                                       // props.history.push(`/shop/search/product-item`)
//                                   },1000)   
//                                   // localStorage.setItem("SearchData" , JSON.stringify(res1) )
//                                   // props.history.push(`/shop/search/product-item`)
      
                                  
//                           })
//                           .catch(err=>{
//                                                         setDisplaySearch(false)

//                             swal("There is An Error")                  
//                               }) 
//       }






//     const SubmitData45342 = (e) =>{
//       e.preventDefault()
//       console.log("df")
//       setDisplaySearch(true)
//       localStorage.removeItem("SearchData")
//           fetch("https://garden-oasis-landscapping-main-back.vercel.app/SearchProduct",{
//                                   method: "POST",
//                                   headers :  {
//                                       "Content-Type" : "application/json" , 
//                                   } ,
//                                   body : JSON.stringify({
//                                       search : search.toLowerCase() ,
      
//                                   })
//                               })
//                               .then(res=>res.json())
//                               .then((res1)=>{ 
                                
//                                 console.log(res1) 
//                                   const SearchProductItem = []
                                  
//                                   let search1 = search.split(" ")
//                                 res1.map((res2,i)=>{
//                                     // console.log(res2.Product_Name.toLowerCase().split(" "),res2.Product_Title.toLowerCase().split(" "),i)
//                                     var Name = res2.Product_Name.toLowerCase().split(" ")
//                                      var Title = res2.Product_Title.toLowerCase().split(" ")
//                                     // console.log(Name , Title)
//                                     for (let j = 0; j < search1.length; j++) {
                                      
//                                       Name.map((res3,i)=>{
  
//                                           if (res3 === search1[j].toLowerCase().trim()){
//                                               SearchProductItem.unshift(res2)
//                                           }
//                                       })
//                                       Title.map((res4,i)=>{
//                                         if (res4 === search1[j].toLowerCase().trim()){
//                                           SearchProductItem.unshift(res2)
//                                         }
//                                       })
//                                     }
//                                 })
//                                   console.log(SearchProductItem)    

//                                   console.log(SearchProductItem,props)
//                                   let uniq = [...new Set(SearchProductItem)];
      
//                                   localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                  
//                                   setDisplaySearch(false)
//                                   setTimeout(()=>{
//                                       history.push("/search/product-item");
      
//                                       // return <Redirect push to="/shop/search/product-item" /> 
//                                       // props.history.push(`/shop/search/product-item`)
//                                   },1000)   
//                                   // localStorage.setItem("SearchData" , JSON.stringify(res1) )
//                                   // props.history.push(`/shop/search/product-item`)
      
                                  
//                           })
//                           .catch(err=>{
//                             console.log(err)
//                             swal("There is An Error")                  
//                             setDisplaySearch(false)
//                               }) 
//       }

// const ChangeCateUrl = (res) =>{
//   console.log("sfsfd")
//   history.push("/categories/"+res+"/all-products")
    
// }




//     const SubmitData = (e) =>{
//         e.preventDefault()

//         fetch("https://garden-oasis-landscapping-main-back.vercel.app/SearchProduct",{
//                                 method: "POST",
//                                 headers :  {
//                                     "Content-Type" : "application/json" , 
//                                 } ,
//                                 body : JSON.stringify({
//                                     search : search.toLowerCase() ,
   
//                                 })
//                             })
//                             .then(res=>res.json())
//                             .then((res1)=>{ 
//                                 console.log(res1)    
//                                 // localStorage.setItem("SearchData" , JSON.stringify(res1) )
//                                 // props.history.push(`/shop/search/product-item`)

//                                 const SearchProductItem = []
//                                 let search1 = search.split(" ")
//                                 res1.map((res2,i)=>{
//                                     // console.log(res2)
//                                     var Name = res2.Product_Name.toLowerCase().split(" ")
//                                      var Title = res2.Product_Title.toLowerCase().split(" ")
//                                     // console.log(Name , Title)
//                                     for (let j = 0; j < search.length; j++) {
                                      
//                                       Name.map((res3,i)=>{
  
//                                           if (res3 === search1[j].toLowerCase().trim()){
//                                               SearchProductItem.unshift(res2)
//                                           }
//                                       })
//                                       Title.map((res4,i)=>{
//                                         if (res4 === search1[j].toLowerCase().trim()){
//                                           SearchProductItem.unshift(res2)
//                                         }
//                                       })
//                                     }
//                                 })
//                                 console.log(SearchProductItem,props)
//                                 let uniq = [...new Set(SearchProductItem)];

//                                 localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                
//                                 setTimeout(()=>{
//                                     history.push("/shop/search/product-item");

//                                     // return <Redirect push to="/shop/search/product-item" /> 
//                                     // props.history.push(`/shop/search/product-item`)
//                                 },1000)
//                         })
//                         .catch(err=>{
//                             // swal("There is An Error")                  
//                             }) 
//     }

//     // const SubmitData4534 = () =>{

//     //     fetch("https://garden-oasis-landscapping-main-back.vercel.app/SearchProduct",{
//     //                             method: "POST",
//     //                             headers :  {
//     //                                 "Content-Type" : "application/json" , 
//     //                             } ,
//     //                             body : JSON.stringify({
//     //                                 search : search.toLowerCase() ,
   
//     //                             })
//     //                         })
//     //                         .then(res=>res.json())
//     //                         .then((res1)=>{ 
//     //                             console.log(res1)    
//     //                             // localStorage.setItem("SearchData" , JSON.stringify(res1) )
//     //                             // props.history.push(`/shop/search/product-item`)

//     //                             const SearchProductItem = []
                                
//     //                             res1.map((res2,i)=>{
//     //                                 // console.log(res2)
//     //                                 var Name = res2.Product_Name.toLowerCase().split(" ")
//     //                                  var Title = res2.Product_Title.toLowerCase().split(" ")
//     //                                 // console.log(Name , Title)
//     //                                 Name.map((res3,i)=>{

//     //                                     if (res3 === search.toLowerCase().trim()){
//     //                                         SearchProductItem.unshift(res2)
//     //                                     }
//     //                                 })
//     //                                 Title.map((res4,i)=>{
//     //                                     if (res4 === search.toLowerCase().trim()){
//     //                                         SearchProductItem.unshift(res2)
//     //                                     }
//     //                                 })
//     //                             })
//     //                             console.log(SearchProductItem,props)
//     //                             let uniq = [...new Set(SearchProductItem)];

//     //                             localStorage.setItem("SearchData" , JSON.stringify(uniq) )
                                
//     //                             setTimeout(()=>{
//     //                                 history.push("/shop/search/product-item");

//     //                                 // return <Redirect push to="/shop/search/product-item" /> 
//     //                                 // props.history.push(`/shop/search/product-item`)
//     //                             },1000)
//     //                     })
//     //                     .catch(err=>{
//     //                         // swal("There is An Error")                  
//     //                         }) 
//     // }

// const setStateChangeMenu = ()=>{
//     if(!displayMenu){
//         setdisplayMenu(true)
//         document.getElementById("mobile-site-hide-show11").style.display = "block"
//     }
//     else{
//         setdisplayMenu(false)
//         document.getElementById("mobile-site-hide-show11").style.display = "none"
//     }

    


// }

//     const basket = useSelector((state) => state.basket);
    
    
    
// const setDisplayMenu3 =() =>{
//   if(document.getElementById("menu-mobile-1").style.visibility === "hidden"){
//     document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
//     document.getElementById("menu-mobile-1").style.visibility = "visible"
//     document.getElementById("menu-mobile-2").style.visibility = "visible"
//   }
//   else{
//     document.getElementById("menu-mobile-1").style.transform = "translateX(280px)"
//     document.getElementById("menu-mobile-1").style.visibility = "hidden"
//     document.getElementById("menu-mobile-2").style.visibility = "hidden"
//   }
// }
    
    
// const setChangeDrop =() =>{
//  console.log("dffdf")
// //  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
// //  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

//     document.getElementById("drop-change").style.visibility = "hidden"
//     document.getElementById("drop-change").style.opacity = 1

// }
// const setChangeDrop1 =() =>{
//  console.log("dffdf")
// //  document.getElementsByClassName('dropdown-menu')[0].style.visibility = "hidden"
// //  document.getElementsByClassName('dropdown-menu')[0].style.opacity = 1

//     // if(document.getElementById("drop-change").style.visibility === "hidden"){
//       document.getElementById("drop-change").style.visibility = "visible"
//       document.getElementById("drop-change").style.opacity = 1
//     // }

// }
//         return (
//             <>
//              { DisplaySearch ?
//                 <Loader
//         type="Puff"
//         color="#00BFFF"
//         height={100}
//         width={100}
//         timeout={10000} //3 secs
//         className="loader-1"
//       /> 
//       :""
// }  
// <header className="header header-intro-clearance header-26">
//               <div className="header-top">
//                 <div>
//                   <div>
//                                       <div className="social-icons social-icons-color justify-content-center">
//                     <span className="social-label">Social Media</span>
//                     <a href="https://www.facebook.com/share/1Cr97R3FzK/" className="social-icon social-facebook" title="Facebook" target="_blank">
//                       <i className="icon-facebook-f" />
//                     </a>
//                     <a href='https://www.tiktok.com/@gardenoasislandscape?_r=1&_t=ZS-91VCI3h2wtO' style={{width:"20px",marginRight: "2rem"}}  title="Tiktok" target="_blank">
// <i className="fab fa-tiktok"  style={{width:"20px",height:"20px",background:"transparent",margin: "0px 0px",
//     color: "black"}}></i>
//                     </a>
//                     <a href="https://www.instagram.com/gardenoasis_landscaping?igsh=MTUzd2R0N20ybGxqaw==" className="social-icon social-instagram" title="Instagram" target="_blank">
//                       <i className="icon-instagram" />
//                     </a>
//                     <a href="https://youtube.com/@gardenoasislandscape?si=8x-Uy8ZCxLGjQokT" className="social-icon social-youtube" title="Youtube" target="_blank">
//                       <i className="icon-youtube" />
//                     </a>
//                   </div>
//                     <marquee behavior="" direction="">
//                    <center>
//                     <span  className="font-weight-normal">
//                      <b style={{color : "black"}}>Discover the perfect plants and garden accessories for your space in Dubai with Garden Oasis Landscaping. 🏡💚


//                       </b> 
//                       </span>
//                    </center>
                    
//                     </marquee>
//                   </div>
                
//                 </div>
//                 {/* End .container */}
//               </div>
//               {/* End .header-top */}
//               <div className="header-middle">
//                 <div className="container">
//                   <div className="header-left">
//                     <button className="mobile-menu-toggler" onClick={()=>setDisplayMenu3()}>
//                       <span className="sr-only">Toggle mobile menu</span>
//                       <i className="icon-bars" />
//                     </button>
//                     <Link to="/" className="logo">
//                       <img src={logo1} alt="Molla Logo" width={145} height={25} />
//                     </Link>
//                   </div>
//                   {/* End .header-left */}
//                   <div className="header-center">
//                     <div className="header-search header-search-visible header-search-no-radius">
//                       <span  className="search-toggle" role="button">
//                         <i className="icon-search" style={{transform: "rotate(280deg)"}} />
//                       </span>
//                       <form onSubmit={(e)=>SubmitData45342(e)}>
//                         <div className="header-search-wrapper search-wrapper-wide">
//                           <div className="select-custom">
//                             <select id="cat1"  onChange={(event) => changeFruit(event.target.value)}>
//                             {/* <select id="cat1"  onChange="location = this.value;" onChange={(event) => changeFruit(event.target.value)}> */}
//                               <option value>All Categories</option>
//                               <option value="/shop-all">Shop All</option>
                              
//                   {MainCatogories.map((res,i)=>{
//                                                           if(res.MainCategories  === "(AMC) Annual Maintenance Contract"){

//                     return (
//                       <>
//                         <option value={"/categories-main/"+"Annual Maintenance Contract"} onClick={()=>ChangeCateUrl(res.MainCategories)}>  {res.MainCategories}</option>

//                        </>
                    
//                     )
//                   }
//                   else if(res.MainCategories  === "Landscaping"){
//                                                             return (
//                                                               <>
//                                                                 <option value={"/categories-main/"+res.MainCategories} onClick={()=>ChangeCateUrl(res.MainCategories)}>  {res.MainCategories}</option>
                                          
//                                                                </>
                                                            
//                                                             )
                                                            
                                                            
//                                                           }
//                                                           else{
//                                                             return (
//                                                               <>
//                                                                 <option value={"/categories/"+res.MainCategories+"/all-products"} onClick={()=>ChangeCateUrl(res.MainCategories)}>  {res.MainCategories}</option>
                                          
//                                                                </>
                                                            
//                                                             )

//                                                           }
//                   })
                

//                               }
                          
//                             </select>
//                           </div>
//                           {/* End .select-custom */}
//                           <label htmlFor="q" className="sr-only">Search</label>
//                           <input type="search" className="form-control" name="q" id="q" required value={search} onChange={(e)=>setSearch(e.target.value)}  style={{ }} placeholder="Search for products, categories, brands, sku..."/>
//                           <button className="btn btn-primary" type="submit">
//                             <i className="icon-search" style={{transform: "rotate(280deg)"}} />
//                           </button>
//                         </div>
//                         {/* End .header-search-wrapper */}
//                       </form>
//                     </div>
//                     {/* End .header-search */}
//                   </div>
//                   <div className="header-right">
//                     <div className="header-dropdown-link">
                     
//                       <div className="wishlist">
//                         <Link to="/whislist" title="Wishlist">
//                           <div className="icon">
//                             <i className="icon-heart-o" />
//                             <span className="wishlist-count badge">{ fav1 ? fav1.length : 0}</span>
//                           </div>
//                           <p>Wishlist</p>
//                         </Link>
//                       </div>
//                       {/* End .compare-dropdown */}
//                       <div className="dropdown cart-dropdown">
//                         <Link className="dropdown-toggle" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" >
//                           <div className="icon" onMouseEnter={()=>setChangeDrop1()} onTouchStart={()=>setChangeDrop1()}>
//                             <i className="icon-shopping-cart" />
//                             <span className="cart-count">{ cart1 ? cart1.length :0}</span>
//                           </div>
//                           <p>Cart</p>
//                         </Link>
//                         <div className="dropdown-menu dropdown-menu-right" id="drop-change">
//                           <div className="dropdown-cart-products">


//                           {
//                           cart1.length >= 1 ? cart1.map((item,i)=>{
//                             return(
//                                 <div className="product">
//                                   <div className="product-cart-details">
//                                     <h4 className="product-title letter-spacing-normal font-size-normal">
//                                       <Link to={"/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id}>Beige knitted elastic runner shoes</Link>
//                                     </h4>
//                                     <span className="cart-product-info">
//                                       <span className="cart-product-qty">{item.Pieces}</span>
//                                       x Rs.{(item.Total_Product_Price /  item.Pieces ).toFixed(0)}
//                                     </span>
//                                   </div>
//                                   {/* End .product-cart-details */}
//                                   <figure className="product-image-container">
//                                     <Link to={"/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id}>
//                                       <img src={item.Product_Image_Upload} alt="Product image"  onClick={()=>props.history.push("/categories/"+item.Product_Catagories+"/"+item.Product_Sub_Catagories+"/"+item.Course_Sub_Catagories+"/all-products/"+item.Product_Name+"/"+item._id)} width={200} height={300} />
//                                     </Link>
//                                   </figure>
                                 
//                               </div>

//                               )
//                             })
//                             : <span style={{textAlign : "center"}}>Cart Empty</span>
//                           }
    

                            
//                           </div>
//                           {/* End .cart-product */}
//                           {/* <div className="dropdown-cart-total">
//                             <span>Total</span>
//                             <span className="cart-total-price">$
//                             {(total1).toFixed(0)

// } 
//                             </span>
//                           </div> */}
//                           {/* End .dropdown-cart-total */}
//                           <div className="dropdown-cart-action">
//                             <Link to="/cart" className="btn btn-outline-primary-2" onClick={()=>setChangeDrop()}>View Cart</Link>
//                             <Link to="/checkout" className="btn btn-outline-primary-2" onClick={()=>setChangeDrop()}>
//                               <span>Checkout</span>
//                               <i className="icon-long-arrow-right" />
//                             </Link>
//                           </div>
//                           {/* End .dropdown-cart-total */}
//                         </div>
//                         {/* End .dropdown-menu */}
//                       </div>
//                       {/* End .cart-dropdown */}
//                     </div>
//                   </div>
                  
//                   {/* End .header-right */}
//                 </div>
                
//                 {/* End .container */}
//               </div>

//               {/* End .header-middle */}









//               <div className="header-top">
//                 <div className="container">
//                 <form onSubmit={(e)=>SubmitData45342(e)} className="mobile-search mobile-search1">
//                 <label htmlFor="mobile-search" className="sr-only">Search</label>
//                 <input type="search" name="mobile-search" id="mobile-search" required value={search} onChange={(e)=>setSearch(e.target.value)} style={{width: "100%",color : "black",background : "white" , border : " none"}} placeholder="Search for products, categories, brands, sku..."/>
//                 <button className="btn btn-primary" type="submit">
//                   <i className="icon-search" style={{transform: "rotate(280deg)"}} />
//                 </button>
//               </form>
                  
//                   {/* End .header-right */}
//                 </div>
//                 {/* End .container */}
//               </div>

































//               <div className="mobile-menu-overlay" />
//           <div className="mobile-menu-container" id="menu-mobile-1">
//             <div className="mobile-menu-wrapper">
//               <span className="mobile-menu-close"  onClick={()=>setDisplayMenu3()}>
//                 <i className="icon-close" />
//               </span>
            
//               <ul className="nav nav-pills-mobile" role="tablist">
//                 <li className="nav-item">
//                   <a className="nav-link font-size-normal second-primary-color font-weight-normal text-uppercase active" id="mobile-cats-link" data-toggle="tab" href="#mobile-cats-tab" role="tab" aria-controls="mobile-cats-tab" aria-selected="false">Categories</a>
//                 </li>
//                 <li className="nav-item">
//                   <a className="nav-link font-size-normal second-primary-color font-weight-normal text-uppercase" id="mobile-menu-link" data-toggle="tab" href="#mobile-menu-tab" role="tab" aria-controls="mobile-menu-tab" aria-selected="true">Menu</a>
//                 </li>
//               </ul>
//               <div className="tab-content">
//                 <div className="tab-pane fade" id="mobile-menu-tab" role="tabpanel" aria-labelledby="mobile-menu-link">
//                   <nav className="mobile-nav">
//                     <ul className="mobile-menu">
//                       <li className="active">
//                         <Link onClick={()=>setDisplayMenu3()} to="/">Home</Link>
//                       </li>
                   
//                           {/* <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/shop-all">Shop All</Link>
//                           </li> */}
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/product/new-arrival">Today's Best</Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/product/expert-pick">
//                               <span>Trending
//                                 <span className="tip tip-hot">Hot</span>
//                               </span>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/product/recommended-product">Features Product</Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/product/recommended-product">
//                               <span>Recommended Product
//                                 <span className="tip tip-new">New</span>
//                               </span>
//                             </Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/cart">Cart</Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/checkout">Checkout</Link>
//                           </li>
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/whislist">Wishlist</Link>
//                           </li>
                      
//                           <li>
//                             <Link onClick={()=>setDisplayMenu3()}  to="/contact">Contact</Link>
                          
//                           </li>
                        
                        
//                     </ul>
//                   </nav>
//                   {/* End .mobile-nav */}
//                 </div>
//                 {/* .End .tab-pane */}
//                 <div className="tab-pane fade show active" id="mobile-cats-tab" role="tabpanel" aria-labelledby="mobile-cats-link">
//                   <nav className="mobile-cats-nav">
//                     <ul className="mobile-cats-menu">
//                     {MainCatogories.map((res,i)=>{
//                      if(res.MainCategories  === "(AMC) Annual Maintenance Contract"){

//                       return (
//                    <>
//                        <li>
//                          <a className="mobile-cats-lead"  href={"/categories-main/"+"Annual Maintenance Contract"}>
//                             {res.MainCategories}</a>
//                        </li>
//                     </>
                 
//                  )      
//                }
//                else if(res.MainCategories  === "Landscaping"){
//                  return (
//               <>
//                   <li>
//                     <a className="mobile-cats-lead"  href={"/categories-main/"+res.MainCategories}>
//                        {res.MainCategories}</a>
//                   </li>
//                </>
            
//             )      
   
                
               
//                }
//                else{
//                  return (
//               <>
//                   <li>
//                     <a  className="mobile-cats-lead" href={"/categories/"+res.MainCategories+"/all-products" }>
//                        {res.MainCategories}</a>
//                   </li>
//                </>
//                  )
//                }
                  
//                   })
                

//                               }
            
//                     </ul>
//                     {/* End .mobile-cats-menu */}
//                   </nav>
//                   {/* End .mobile-cats-nav */}
//                 </div>
//                 {/* .End .tab-pane */}
//               </div>
//               {/* End .tab-content */}
//               <div className="social-icons justify-content-center">
//                 <a href="https://www.facebook.com/gol.flowers.uae" className="social-icon" target="_blank" title="Facebook">
//                   <i className="icon-facebook-f" />
//                 </a>
               
//                 <a href="https://www.instagram.com/gol.flowers_uae" className="social-icon" target="_blank" title="Instagram">
//                   <i className="icon-instagram" />
//                 </a>
//                 <a href="https://www.tiktok.com/@gardenoasis1" className="social-icon" target="_blank" title="Youtube">
//                   <i className="icon-tiktok" />
//                 </a>
//               </div>
//               {/* End .social-icons */}
//             </div>
//             {/* End .mobile-menu-wrapper */}
//           </div>















//           <div className="mobile-menu-container1" id="menu-mobile-2" onClick={()=>setDisplayMenu3()}>
//             <div className="mobile-menu-wrapper1">
//               {/* End .social-icons */}
//             </div>
//             {/* End .mobile-menu-wrapper */}
//           </div>













//           {/* End .mobile-menu-container */}
//           {/* Sign in / Register Modal */}
//           <div className="modal fade" id="signin-modal" tabIndex={-1} role="dialog" aria-hidden="true">
//             <div className="modal-dialog modal-dialog-centered" role="document">
//               <div className="modal-content">
//                 <div className="modal-body">
//                   <button type="button" className="close" data-dismiss="modal" aria-label="Close">
//                     <span aria-hidden="true">
//                       <i className="icon-close" />
//                     </span>
//                   </button>
//                   <div className="form-box">
//                     <div className="form-tab">
//                       <ul className="nav nav-pills nav-fill" role="tablist">
//                         <li className="nav-item">
//                           <a className="nav-link font-size-normal second-primary-color active" id="signin-tab" data-toggle="tab" href="#signin" role="tab" aria-controls="signin" aria-selected="true">Sign In</a>
//                         </li>
//                         <li className="nav-item">
//                           <a className="nav-link font-size-normal second-primary-color" id="register-tab" data-toggle="tab" href="#register" role="tab" aria-controls="register" aria-selected="false">Register</a>
//                         </li>
//                       </ul>
//                       <div className="tab-content" id="tab-content-5">
//                         <div className="tab-pane fade show active" id="signin" role="tabpanel" aria-labelledby="signin-tab">
//                           <form action="#">
//                             <div className="form-group">
//                               <label htmlFor="singin-email">Username or email address *</label>
//                               <input type="text" className="form-control" id="singin-email" name="singin-email" required />
//                             </div>
//                             {/* End .form-group */}
//                             <div className="form-group">
//                               <label htmlFor="singin-password">Password *</label>
//                               <input type="password" className="form-control" id="singin-password" name="singin-password" required />
//                             </div>
//                             {/* End .form-group */}
//                             <div className="form-footer">
//                               <button type="submit" className="btn btn-outline-primary-2">
//                                 <span>LOG IN</span>
//                                 <i className="icon-long-arrow-right" />
//                               </button>
//                               <div className="custom-control custom-checkbox">
//                                 <input type="checkbox" className="custom-control-input" id="signin-remember" />
//                                 <label className="custom-control-label" htmlFor="signin-remember">Remember Me</label>
//                               </div>
//                               {/* End .custom-checkbox */}
//                               <span className="forgot-link">Forgot Your Password?</span>
//                             </div>
//                             {/* End .form-footer */}
//                           </form>
//                           <div className="form-choice">
//                             <p className="text-center">or sign in with</p>
//                             <div className="row">
//                               <div className="col-sm-6">
//                                 <span className="btn btn-login btn-g">
//                                   <i className="icon-google" />
//                                   Login With Google
//                                 </span>
//                               </div>
//                               {/* End .col-6 */}
//                               <div className="col-sm-6">
//                                 <span className="btn btn-login btn-f">
//                                   <i className="icon-facebook-f" />
//                                   Login With Facebook
//                                 </span>
//                               </div>
//                               {/* End .col-6 */}
//                             </div>
//                             {/* End .row */}
//                           </div>
//                           {/* End .form-choice */}
//                         </div>
//                         {/* .End .tab-pane */}
//                         <div className="tab-pane fade" id="register" role="tabpanel" aria-labelledby="register-tab">
//                           <form action="#">
//                             <div className="form-group">
//                               <label htmlFor="register-email">Your email address *</label>
//                               <input type="email" className="form-control" id="register-email" name="register-email" required />
//                             </div>
//                             {/* End .form-group */}
//                             <div className="form-group">
//                               <label htmlFor="register-password">Password *</label>
//                               <input type="password" className="form-control" id="register-password" name="register-password" required />
//                             </div>
//                             {/* End .form-group */}
//                             <div className="form-footer">
//                               <button type="submit" className="btn btn-outline-primary-2">
//                                 <span>SIGN UP</span>
//                                 <i className="icon-long-arrow-right" />
//                               </button>
//                               <div className="custom-control custom-checkbox">
//                                 <input type="checkbox" className="custom-control-input" id="register-policy" required />
//                                 <label className="custom-control-label" htmlFor="register-policy">I agree to the
//                                   <span>privacy policy</span> *</label>
//                               </div>
//                               {/* End .custom-checkbox */}
//                             </div>
//                             {/* End .form-footer */}
//                           </form>
//                           <div className="form-choice">
//                             <p className="text-center">or sign in with</p>
//                             <div className="row">
//                               <div className="col-sm-6">
//                                 <span className="btn btn-login btn-g">
//                                   <i className="icon-google" />
//                                   Login With Google
//                                 </span>
//                               </div>
//                               {/* End .col-6 */}
//                               <div className="col-sm-6">
//                                 <span className="btn btn-login  btn-f">
//                                   <i className="icon-facebook-f" />
//                                   Login With Facebook
//                                 </span>
//                               </div>
//                               {/* End .col-6 */}
//                             </div>
//                             {/* End .row */}
//                           </div>
//                           {/* End .form-choice */}
//                         </div>
//                         {/* .End .tab-pane */}
//                       </div>
//                       {/* End .tab-content */}
//                     </div>
//                     {/* End .form-tab */}
//                   </div>
//                   {/* End .form-box */}
//                 </div>
//                 {/* End .modal-body */}
//               </div>
//               {/* End .modal-content */}
//             </div>
//             {/* End .modal-dialog */}
//           </div>
//           {/* End .modal */}
//               {/* End .header-bottom */}
//             </header>
//         </>
//         )
// }

// export default Header;










import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo1 from "../assets/images/logo-kar.jpeg";

const Header = () => {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileServicesOpen, setMobileServicesOpen] = useState(false);

  const closeMobileMenu = () => {
    setMobileMenu(false);
    setMobileServicesOpen(false);
  };

  // WhatsApp number یہاں ڈالیں
  const whatsappNumber = "971509480695";

  const whatsappMessage = encodeURIComponent(
    "Hello, I would like to get a quote for your services."
  );

  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <>
      <header className="service-header">
        <div className="service-header-container">

          {/* =========================
              LOGO
          ========================== */}
          <div className="service-logo">
            <Link to="/" onClick={closeMobileMenu}>
              <img
                src={logo1}
                alt="Garden Oasis Landscaping"
              />
            </Link>
          </div>


          {/* =========================
              DESKTOP NAVIGATION
          ========================== */}
          <nav className="service-navigation">

            <Link to="/" className="service-nav-link">
              Home
            </Link>

            <Link to="/about" className="service-nav-link">
              About
            </Link>


            {/* SERVICES DROPDOWN */}
            <div
              className="service-dropdown"
              onMouseEnter={() => setServicesOpen(true)}
              onMouseLeave={() => setServicesOpen(false)}
            >
              <button
                type="button"
                className="service-nav-link service-dropdown-button"
                onClick={() => setServicesOpen(!servicesOpen)}
              >
                Services
                <span className="dropdown-arrow">▼</span>
              </button>

              {servicesOpen && (
                <div className="service-dropdown-menu">

                  {/* <Link
                    to="/services"
                    className="service-dropdown-item"
                  >
                    All Services
                  </Link>

                  <Link
                    to="/services/landscaping"
                    className="service-dropdown-item"
                  >
                    Landscaping
                  </Link>

                  <Link
                    to="/services/garden-maintenance"
                    className="service-dropdown-item"
                  >
                    Garden Maintenance
                  </Link>

                  <Link
                    to="/services/irrigation"
                    className="service-dropdown-item"
                  >
                    Irrigation
                  </Link>

                  <Link
                    to="/services/garden-design"
                    className="service-dropdown-item"
                  >
                    Garden Design
                  </Link> */}






  <Link
                  to="/best-landscaping-service-dubai"
                                      className="service-dropdown-item"

                >
                  Landscaping Services
                </Link>

                <Link
                  to="/amc-packages-dubai-annual-maintenance-contract"
                                      className="service-dropdown-item"

                >
                 AMC Annual Garden Maintenance
                </Link>

                <Link
                  to="/#1-swimming-pool-and-landscaping-company-in-dubai-uae"
                                      className="service-dropdown-item"

                >
                  Swimming Pool Maintenance
                </Link>

                <Link
                  to="/garden-maintenance-services-dubai"
                                      className="service-dropdown-item"

                >
                  Garden Design
                </Link>







                </div>
              )}
            </div>


            <Link to="/portfolio" className="service-nav-link">
             Our Portfolio
            </Link>
            <Link to="/contact" className="service-nav-link">
              Contact
            </Link>


            {/* GET A QUOTE BUTTON */}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="quote-button"
            >
              <span className="whatsapp-icon">◉</span>
              Get a Quote
            </a>

          </nav>


          {/* =========================
              MOBILE BUTTON
          ========================== */}
          <button
            type="button"
            className="service-mobile-button"
            onClick={() => setMobileMenu(!mobileMenu)}
            aria-label="Toggle navigation menu"
            aria-expanded={mobileMenu}
          >
            {mobileMenu ? (
              <span className="service-close-icon">&times;</span>
            ) : (
              <>
                <span></span>
                <span></span>
                <span></span>
              </>
            )}
          </button>

        </div>


        {/* =========================
            MOBILE MENU
        ========================== */}
        <div
          className={`service-mobile-menu ${
            mobileMenu ? "service-mobile-menu-open" : ""
          }`}
        >

          <Link
            to="/"
            className="service-mobile-link"
            onClick={closeMobileMenu}
          >
            Home
          </Link>


          <Link
            to="/about"
            className="service-mobile-link"
            onClick={closeMobileMenu}
          >
            About
          </Link>


          {/* MOBILE SERVICES */}
          <div className="mobile-services-wrapper">

            <button
              type="button"
              className="service-mobile-link mobile-services-button"
              onClick={() =>
                setMobileServicesOpen(!mobileServicesOpen)
              }
            >
              <span>Services</span>

              <span
                className={`mobile-arrow ${
                  mobileServicesOpen ? "mobile-arrow-open" : ""
                }`}
              >
                ▼
              </span>
            </button>


            {mobileServicesOpen && (
              <div className="mobile-services-dropdown">

                {/* <Link
                  to="/services"
                  onClick={closeMobileMenu}
                >
                  All Services
                </Link> */}

                <Link
                  to="/best-landscaping-service-dubai"
                  onClick={closeMobileMenu}
                >
                  Landscaping Services
                </Link>

                <Link
                  to="/amc-packages-dubai-annual-maintenance-contract"
                  onClick={closeMobileMenu}
                >
                 AMC Annual Garden Maintenance
                </Link>

                <Link
                  to="/#1-swimming-pool-and-landscaping-company-in-dubai-uae"
                  onClick={closeMobileMenu}
                >
                  Swimming Pool Maintenance
                </Link>

                <Link
                  to="/garden-maintenance-services-dubai"
                  onClick={closeMobileMenu}
                >
                  Garden Design
                </Link>

              </div>
            )}

          </div>


 <Link to="/portfolio"  className="service-mobile-link"          onClick={closeMobileMenu}
>
             Our Portfolio
            </Link>



          <Link
            to="/contact"
            className="service-mobile-link"
            onClick={closeMobileMenu}
          >
            Contact
          </Link>


          {/* MOBILE GET QUOTE */}
          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="mobile-quote-button"
            onClick={closeMobileMenu}
          >
            <span className="whatsapp-icon">◉</span>
            Get a Quote
          </a>

        </div>

      </header>


      {/* =========================
          CSS
      ========================== */}

      <style>
        {`

        /* ==========================================
           MAIN HEADER
        ========================================== */

        .service-header {
          width: 100%;
          background: #ffffff;
          position: relative;
          z-index: 9999;
          box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
        }


        .service-header-container {
          width: 100%;
          max-width: 1200px;
          height: 85px;
          margin: 0 auto;
          padding: 0 25px;

          display: flex;
          align-items: center;
          justify-content: space-between;
        }


        /* ==========================================
           LOGO
        ========================================== */

        .service-logo {
          display: flex;
          align-items: center;
          flex-shrink: 0;
        }

        .service-logo a {
          display: flex;
          align-items: center;
          text-decoration: none;
        }

        .service-logo img {
          width: 145px;
          height: auto;
          max-height: 65px;
          object-fit: contain;
          display: block;
        }


        /* ==========================================
           DESKTOP NAVIGATION
        ========================================== */

        .service-navigation {
          display: flex;
          align-items: center;
          justify-content: center;

          gap: 35px;

          margin-left: auto;
        }


        .service-nav-link {
          position: relative;

          color: #222222;
          text-decoration: none;

          font-size: 16px;
          font-weight: 500;

          padding: 10px 0;

          background: none;
          border: none;

          cursor: pointer;

          transition: all 0.3s ease;
        }


        .service-nav-link:hover {
          color: #4b8b3b;
          text-decoration: none;
        }


        .service-nav-link::after {
          content: "";

          position: absolute;

          left: 0;
          bottom: 0;

          width: 0;
          height: 2px;

          background: #4b8b3b;

          transition: width 0.3s ease;
        }


        .service-nav-link:hover::after {
          width: 100%;
        }


        /* ==========================================
           SERVICES DROPDOWN
        ========================================== */

        .service-dropdown {
          position: relative;
          height: 100%;

          display: flex;
          align-items: center;
        }


        .service-dropdown-button {
          display: flex;
          align-items: center;
          gap: 6px;
        }


        .dropdown-arrow {
          font-size: 16px;
          line-height: 1;

          transition: transform 0.3s ease;
        }


        .service-dropdown:hover .dropdown-arrow {
          transform: rotate(180deg);
        }


        .service-dropdown-menu {
          position: absolute;

          top: calc(100% + 10px);
          left: 50%;

          transform: translateX(-50%);

          width: 230px;

          background: #ffffff;

          border-radius: 8px;

          padding: 8px 0;

          box-shadow:
            0 10px 30px rgba(0, 0, 0, 0.12);

          border: 1px solid #eeeeee;

          animation: dropdownAnimation 0.2s ease;
        }


        @keyframes dropdownAnimation {

          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-8px);
          }

          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }

        }


        .service-dropdown-item {
          display: block;

          width: 100%;

          padding: 12px 20px;

          color: #333333;

          text-decoration: none;

          font-size: 15px;

          transition: all 0.25s ease;
        }


        .service-dropdown-item:hover {
          background: #f3f8f1;
          color: #4b8b3b;

          padding-left: 25px;

          text-decoration: none;
        }


        /* ==========================================
           GET A QUOTE BUTTON
        ========================================== */

        .quote-button {
          display: inline-flex;

          align-items: center;
          justify-content: center;

          gap: 8px;

          min-width: 135px;

          padding: 12px 20px;

          color: #ffffff !important;

          background: #4b8b3b;

          border-radius: 30px;

          font-size: 14px;
          font-weight: 600;

          text-decoration: none !important;

          border: 2px solid #4b8b3b;

          transition: all 0.3s ease;

          box-shadow:
            0 5px 15px rgba(75, 139, 59, 0.22);
        }


        .quote-button:hover {
          background: #ffffff;

          color: #4b8b3b !important;

          transform: translateY(-2px);

          box-shadow:
            0 8px 20px rgba(75, 139, 59, 0.28);
        }


        .whatsapp-icon {
          font-size: 15px;
          line-height: 1;
        }


        /* ==========================================
           MOBILE BUTTON
        ========================================== */

        .service-mobile-button {
          display: none;

          width: 42px;
          height: 42px;

          border: none;

          background: transparent;

          padding: 8px;

          cursor: pointer;

          flex-direction: column;

          align-items: center;
          justify-content: center;

          gap: 5px;
        }


        .service-mobile-button span:not(.service-close-icon) {
          display: block;

          width: 25px;
          height: 2px;

          background: #222222;

          border-radius: 2px;
        }


        .service-close-icon {
          font-size: 35px;
          line-height: 30px;

          color: #222222;

          font-weight: 300;
        }


        /* ==========================================
           MOBILE MENU
        ========================================== */

        .service-mobile-menu {
          display: none;

          width: 100%;

          background: #ffffff;

          border-top: 1px solid #eeeeee;

          padding: 10px 20px 20px;

          box-shadow:
            0 8px 20px rgba(0, 0, 0, 0.08);
        }


        .service-mobile-menu-open {
          display: flex;

          flex-direction: column;
        }


        .service-mobile-link {
          width: 100%;

          padding: 14px 5px;

          color: #222222;

          text-decoration: none;

          font-size: 16px;

          font-weight: 500;

          border-bottom: 1px solid #eeeeee;

          background: transparent;

          transition: all 0.3s ease;
        }


        .service-mobile-link:hover {
          color: #4b8b3b;

          padding-left: 10px;

          text-decoration: none;
        }


        /* ==========================================
           MOBILE SERVICES
        ========================================== */

        .mobile-services-wrapper {
          width: 100%;
        }


        .mobile-services-button {
          display: flex;

          align-items: center;
          justify-content: space-between;

          border: none;

          cursor: pointer;

          text-align: left;
        }


        .mobile-arrow {
          font-size: 18px;

          transition: transform 0.3s ease;
        }


        .mobile-arrow-open {
          transform: rotate(180deg);
        }


        .mobile-services-dropdown {
          background: #f7faf6;

          padding: 5px 0;

          border-bottom: 1px solid #eeeeee;
        }


        .mobile-services-dropdown a {
          display: block;

          padding: 11px 15px;

          color: #444444;

          font-size: 14px;

          text-decoration: none;

          transition: all 0.2s ease;
        }


        .mobile-services-dropdown a:hover {
          color: #4b8b3b;

          padding-left: 22px;
        }


        /* ==========================================
           MOBILE GET QUOTE
        ========================================== */

        .mobile-quote-button {
          display: flex;

          align-items: center;
          justify-content: center;

          gap: 8px;

          width: 100%;

          margin-top: 15px;

          padding: 13px 20px;

          color: #ffffff !important;

          background: #4b8b3b;

          border: 2px solid #4b8b3b;

          border-radius: 30px;

          font-size: 15px;

          font-weight: 600;

          text-decoration: none !important;

          transition: all 0.3s ease;
        }


        .mobile-quote-button:hover {
          background: #ffffff;

          color: #4b8b3b !important;
        }


        /* ==========================================
           TABLET
        ========================================== */

        @media (max-width: 991px) {

          .service-header-container {
            height: 75px;

            padding: 0 20px;
          }


          .service-navigation {
            gap: 23px;
          }


          .service-nav-link {
            font-size: 15px;
          }


          .quote-button {
            min-width: 120px;

            padding: 10px 15px;
          }


          .service-logo img {
            width: 135px;
          }

        }


        /* ==========================================
           MOBILE
        ========================================== */

        @media (max-width: 767px) {

          .service-header-container {
            height: 70px;

            padding: 0 18px;
          }


          .service-logo img {
            width: 125px;

            max-height: 55px;
          }


          /* Hide desktop nav */

          .service-navigation {
            display: none;
          }


          /* Show mobile button */

          .service-mobile-button {
            display: flex;
          }


          .service-mobile-menu {
            display: none;
          }


          .service-mobile-menu-open {
            display: flex;
          }

        }


        /* ==========================================
           SMALL MOBILE
        ========================================== */

        @media (max-width: 480px) {

          .service-header-container {
            height: 65px;

            padding: 0 15px;
          }


          .service-logo img {
            width: 115px;
          }


          .service-mobile-button {
            width: 40px;
            height: 40px;
          }


          .service-mobile-link {
            font-size: 15px;

            padding: 13px 5px;
          }


          .mobile-services-dropdown a {
            font-size: 14px;
          }

        }

        `}
      </style>
    </>
  );
};

export default Header;
